import React from "react";
import { Text } from "react-native";
import { useDimensionsContext } from "contexts";

export const KMessageText = ({ message }) => {
  const { getScaledFontSize } = useDimensionsContext();

  return <Text style={{ fontSize: getScaledFontSize(1) }}>{message.text}</Text>;
};
